import { GameType } from '@/models/games/enums/GameType';
import { TableMode } from '@/models/TableMode';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { SupportedGame } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import { convertResultToRecord } from '../../../utils/games/teenpatti';
import { TeenPattiResult } from '../../games/teenpatti';
import { CMDScInitTeenPatti2020, ICommand } from '../live';
import { CMDTeenPatti2020 } from '../live/CMDTeenPatti2020';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitTeenPattiHandler extends AbstractHandler {
    _command: CMDScInitTeenPatti2020;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitTeenPatti2020;
    }
    override convertResult(result: CMDTeenPatti2020): TeenPattiResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            {
                PlayerACard: result.PlayerACard,
                PlayerBCard: result.PlayerBCard,
            }
        ) as TeenPattiResult;
        return newResult;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const liveData = {} as SupportedGameLiveData;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        liveData.GameType = GameType.TeenPatti2020;
        liveData.CurrentState = this._command.CurrentState;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        game.OldResult = this._command.OldResult.filter(o => {
            if (o.BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );
        liveData.ResultReleased = false;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;

        if (game.OldResult.length > 100) {
            game.OldResult = game.OldResult.slice(48);
        }

        if (
            game.OldResult &&
            game.OldResult.length > 0 &&
            game.OldResult[0].GameCount != 1
        ) {
            let offset = game.OldResult[0].GameCount % 6;
            game.OldResult = game.OldResult.slice(6 - offset + 1);
        }

        const convertedRecord = game.OldResult.map(r =>
            convertResultToRecord(r as TeenPattiResult)
        );

        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseResult.GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record:
                        convertedRecord.length > 50
                            ? convertedRecord.splice(
                                  convertedRecord.length - 50
                              )
                            : convertedRecord,
                })
            );
        });
    }
}
